import React from "react";
import { TrendingUp, Target, MessageSquare, Share2 } from "lucide-react";

export const ReportMarketing = ({ strategy }) => {
  const ms = strategy.marketing_strategy || {};
  return (
    <div className="space-y-6">
      {ms.key_messages && (
        <div className="bg-gradient-to-br from-emerald-900/30 to-slate-900 border border-emerald-500/30 rounded-2xl p-6">
          <h3 className="font-semibold text-emerald-400 mb-4 flex items-center gap-2">
            <MessageSquare className="w-5 h-5" /> Key Messages
          </h3>
          <div className="space-y-3">
            {ms.key_messages.map((msg, i) => (
              <div key={`msg-${msg.slice(0, 30)}-${i}`} className="p-4 bg-slate-800/50 rounded-xl text-slate-300 text-lg font-medium">
                &ldquo;{msg}&rdquo;
              </div>
            ))}
          </div>
        </div>
      )}

      {ms.content_pillars && (
        <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6">
          <h3 className="font-semibold text-white mb-4 flex items-center gap-2">
            <Target className="w-5 h-5 text-emerald-400" /> Content Pillars
          </h3>
          <div className="grid md:grid-cols-2 gap-4">
            {ms.content_pillars.map((pillar, i) => {
              const label = typeof pillar === "object" ? pillar.pillar || pillar.name : pillar;
              const desc = typeof pillar === "object" ? pillar.description : null;
              return (
                <div key={`pillar-${label}-${i}`} className="p-4 bg-slate-800/50 rounded-xl">
                  <h4 className="font-semibold text-emerald-400 mb-1">{label}</h4>
                  {desc && <p className="text-slate-300 text-sm">{desc}</p>}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {ms.channel_strategy && (
        <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6">
          <h3 className="font-semibold text-white mb-4 flex items-center gap-2">
            <Share2 className="w-5 h-5 text-emerald-400" /> Channel Strategy
          </h3>
          <div className="space-y-4">
            {ms.channel_strategy.map((ch, i) => {
              const name = typeof ch === "object" ? ch.channel || ch.name : ch;
              return (
                <div key={`channel-${name}-${i}`} className="p-4 bg-slate-800/50 rounded-xl">
                  <h4 className="font-semibold text-white mb-1">{name}</h4>
                  {typeof ch === "object" && ch.strategy && <p className="text-slate-300 text-sm mb-2">{ch.strategy}</p>}
                  {typeof ch === "object" && ch.posting_frequency && (
                    <p className="text-slate-500 text-xs">Frequency: {ch.posting_frequency}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {ms.growth_tactics && (
        <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6">
          <h3 className="font-semibold text-white mb-4 flex items-center gap-2">
            <TrendingUp className="w-5 h-5 text-emerald-400" /> Growth Tactics
          </h3>
          <ul className="space-y-2">
            {ms.growth_tactics.map((tactic) => {
              const label = typeof tactic === "object" ? tactic.tactic || tactic.name : tactic;
              return (
                <li key={`tactic-${label}`} className="flex items-start gap-2 text-slate-300">
                  <TrendingUp className="w-4 h-4 mt-1 text-emerald-400 flex-shrink-0" /> {label}
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
};
